import React from "react";
import { Route, Routes } from "react-router-dom";

import LoginPage from "../pages/LoginPage";
import HomePage from "../pages/HomePage";
import UserPage from "../pages/UserPage";
import Navbar from "../components/Navbar";
import ProfesionalesPage from "../pages/ProfesionalesPage";
import ProcesosPage from "../pages/ProcesosPage";
import EstadoProcesoPage from "../pages/EstadoProcesoPage";
import ModalidadesPage from "../pages/ModalidadesPage";
import PersonasPage from "../pages/PersonasPage";
import CartasPage from "../pages/CartasPage";

import { UserContextProvider } from "../context/UserContext";
import { PersonContextProvider } from "../context/PersonContext";
import { ProfessionalContextProvider } from "../context/ProfessionalContext";
import { SpecialtiesContextProvider } from "../context/SpecialtiesContext";
import EspecialidadesPage from "../pages/EspecialidadesPage";
import { StatusProcessContextProvider } from "../context/StatusProcessContext";
import { ModalitiesContextProvider } from "../context/ModalitiesContext";
import OpcionesModalidadesPage from "../pages/OpcionesModalidadesPage";
import { OptionsModalitiesContextProvider } from "../context/OptionsModalitiesContext";
import OpcionesEstadoProcesoPage from "../pages/OpcionesEstadoProcesoPage";
import { OptionsStatusProcessContextProvider } from "../context/OptionsStatusProcessContext";
import { ProcessesContextProvider } from "../context/ProcessContext";
import { DataBaseContextProvider } from "../context/DataBaseContext";
import { LoginContextProvider } from "../context/LoginContext";
import AudienciasPage from "../pages/AudienciasPage";
import EscritosPage from "../pages/EscritosPage";
import ExpedientePage from "../pages/ExpedientePage";
import ResolucionesPage from "../pages/ResolucionesPage";
import NotificacionesPage from "../pages/NotificacionesPage";
import DashboardPage from "../pages/DashboardPage";

const AppRouter = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Navbar />}>
          <Route
            index
            element={
              <DataBaseContextProvider>
                <HomePage />
              </DataBaseContextProvider>
            }
          />
          <Route
            path="usuarios"
            element={
              <UserContextProvider>
                <UserPage />
              </UserContextProvider>
            }
          />
          <Route
            path="arbitros"
            element={
              <ProfessionalContextProvider>
                <SpecialtiesContextProvider>
                  <ProfesionalesPage />
                </SpecialtiesContextProvider>
              </ProfessionalContextProvider>
            }
          />
          <Route
            path="personas"
            element={
              <PersonContextProvider>
                <PersonasPage />
              </PersonContextProvider>
            }
          />
          <Route
            path="especialidades"
            element={
              <SpecialtiesContextProvider>
                <EspecialidadesPage />
              </SpecialtiesContextProvider>
            }
          />
          <Route
            path="procesos"
            element={
              <DataBaseContextProvider>
                <ProcessesContextProvider>
                  <PersonContextProvider>
                    <ModalitiesContextProvider>
                      <OptionsModalitiesContextProvider>
                        <StatusProcessContextProvider>
                          <ProcesosPage />
                        </StatusProcessContextProvider>
                      </OptionsModalitiesContextProvider>
                    </ModalitiesContextProvider>
                  </PersonContextProvider>
                </ProcessesContextProvider>
              </DataBaseContextProvider>
            }
          />
          <Route
            path="modalidades"
            element={
              <ModalitiesContextProvider>
                <ModalidadesPage />
              </ModalitiesContextProvider>
            }
          />
          <Route
            path="opciones_modalidad"
            element={
              <OptionsModalitiesContextProvider>
                <ModalitiesContextProvider>
                  <OpcionesModalidadesPage />
                </ModalitiesContextProvider>
              </OptionsModalitiesContextProvider>
            }
          />
          <Route
            path="estado_proceso"
            element={
              <StatusProcessContextProvider>
                <EstadoProcesoPage />
              </StatusProcessContextProvider>
            }
          />
          <Route
            path="opciones_estado"
            element={
              <OptionsStatusProcessContextProvider>
                <StatusProcessContextProvider>
                  <OpcionesEstadoProcesoPage />
                </StatusProcessContextProvider>
              </OptionsStatusProcessContextProvider>
            }
          />
          <Route
            path="cartas"
            element={
              <LoginContextProvider>
                <DataBaseContextProvider>
                  <CartasPage />
                </DataBaseContextProvider>
              </LoginContextProvider>
            }
          />
          <Route
            path="audiencias"
            element={
              <LoginContextProvider>
                <DataBaseContextProvider>
                  <AudienciasPage />
                </DataBaseContextProvider>
              </LoginContextProvider>
            }
          />
          <Route
            path="escritos"
            element={
              <LoginContextProvider>
                <DataBaseContextProvider>
                  <EscritosPage />
                </DataBaseContextProvider>
              </LoginContextProvider>
            }
          />
          <Route
            path="resoluciones"
            element={
              <LoginContextProvider>
                <DataBaseContextProvider>
                  <ResolucionesPage />
                </DataBaseContextProvider>
              </LoginContextProvider>
            }
          />
          <Route
            path="expediente"
            element={
              <LoginContextProvider>
                <DataBaseContextProvider>
                  <ExpedientePage />
                </DataBaseContextProvider>
              </LoginContextProvider>
            }
          />
          <Route
            path="notificaciones"
            element={
              <LoginContextProvider>
                <DataBaseContextProvider>
                  <NotificacionesPage />
                </DataBaseContextProvider>
              </LoginContextProvider>
            }
          />
          <Route
            path="dashboard"
            element={
              <LoginContextProvider>
                <DataBaseContextProvider>
                  <DashboardPage />
                </DataBaseContextProvider>
              </LoginContextProvider>
            }
          />
        </Route>
        <Route path="login" element={<LoginPage />} />
        <Route path="*" element={<h1>NOT FOUND</h1>} />
      </Routes>
    </>
  );
};

export default AppRouter;
